import {PatientDisplayFormat} from '../enums/patient-display-format.enum';

/**
 * Minimal patient shape needed for name formatting — structurally satisfied
 * by CalendarAppointmentPatient, QueryPatient and Patient.
 */
export interface DisplayablePatient {
  name?: string;
  fullName?: string;
  displayName?: string;
  fullDisplayName?: string;
  formalName?: string;
}

/**
 * Return the patient's name formatted according to the practice's
 * defaultPatientDisplayFormat. Falls back to the best available name
 * variant when the requested field is empty.
 */
export function formatPatientName(
  patient: DisplayablePatient | null | undefined,
  format: PatientDisplayFormat | null | undefined
): string {
  if (!patient) return '';
  const fallback = patient.formalName || patient.displayName || patient.fullDisplayName || patient.fullName || patient.name || '';
  switch (format) {
    case PatientDisplayFormat.Name: return patient.name || fallback;
    case PatientDisplayFormat.FullName: return patient.fullName || fallback;
    case PatientDisplayFormat.DisplayName: return patient.displayName || fallback;
    case PatientDisplayFormat.FullDisplayName: return patient.fullDisplayName || fallback;
    case PatientDisplayFormat.FormalName: return patient.formalName || fallback;
    default: return fallback;
  }
}
